import { PayloadAction } from "@reduxjs/toolkit";
import { OrderSecondStepData } from 'entities/cards';

import { IState } from "../types/state";

const action = (state: IState, payloadAction: PayloadAction<OrderSecondStepData>) => {
  state.orderSecondStep.data = payloadAction.payload;
};

export default action;
